// extracted by css-extract-rspack-plugin
export default {"title":"cookie-consent-Accordion-title-044d1a4a","body":"cookie-consent-Accordion-body-cbe6d884","visible":"cookie-consent-Accordion-visible-25d8b396"};